import { useQuery } from "@tanstack/react-query";
import api from "@/lib/axios-interceptor";

export default function useAlertQuery() {
  const { data, isLoading, isError } = useQuery<types.WeatherAlert>({
    queryKey: ["alerts"],
    queryFn: async () => {
      const res = await api.get<types.WeatherAlert>(`/v1/alerts`); //?date=2024-05-10

      return res.data;
    },
  });

  return {
    data,
    isLoading,
    isError,
  };
}
